import { render, staticRenderFns } from "./kakao.vue?vue&type=template&id=b05f5524"
import script from "./kakao.vue?vue&type=script&lang=js"
export * from "./kakao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports